export async function TratamientoAdminCreate(pacienteid, date, estado, slug, medicoSelected, psicoHospSelected, psicologoSelected, nutricionSelected, entrenamientoSelected, mindfulnessSelected, especialistasSelected, citaNotificacionId) {
    console.log(pacienteid, date, estado, slug, medicoSelected, psicoHospSelected, psicologoSelected, nutricionSelected, entrenamientoSelected, mindfulnessSelected, especialistasSelected);
    const formData = {
        name: slug,
        meta: {
            fecha: date,
            paciente: pacienteid,
            estado: estado,
            medico: medicoSelected,
            psicohosp: psicoHospSelected,
            psicologo: psicologoSelected,
            nutricion: nutricionSelected,
            entrenamiento: entrenamientoSelected,
            mindfulness: mindfulnessSelected,
            especialistas: especialistasSelected,
            citaNotificacionId: citaNotificacionId,
        }
        
    };

	const authToken = sessionStorage.getItem( 'token' );

        try {
            const response = await fetch('https://app.tavad.com/hce/wp-json/wp/v2/tratamiento', {
                method: 'POST',
                headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json',
                'Authorization': `Bearer ${ authToken }`,
                
                },
                body: JSON.stringify(formData),
            } );
            const values = await response.json();
            console.log(values);
            return values;
        } catch (error) {
            console.error(error);
        }

}